import { computed } from "@vue/composition-api";

export function get(context: any, path: string) {
  return computed(() => context.root.$store.get(path));
}
